import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = ["id"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["slotwrapper flex gap-x-1 justify-center", {
      wiggle: _ctx.row.tried === true,
    }]),
    id: 'guess-' + _ctx.rowIndex
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.row.letters, (char, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: char.id,
        class: _normalizeClass(["flex items-center justify-center", {
        flipcardAniamtion: char.flipped === true,
      }])
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["grid content-center border-2 border-gray-400 w-14 h-14 sm:w-16 sm:h-16 text-3xl font-bold text-center", {
          darkModeRows: _ctx.darkMode,
          active1: char.letter.length > 0,
          inword: char.inWord === true,
          double2: char.doubleLetter === true,
          inposition: char.rightPosition === true,
          notInword: char.notInWord === true,
        }]),
          id: 'letter-' + _ctx.rowIndex + '-' + ++index
        }, _toDisplayString(char.letter), 11, _hoisted_2)
      ], 2))
    }), 128))
  ], 10, _hoisted_1))
}